document.addEventListener('DOMContentLoaded', function() {

  // Mobile menu toggle
  var menuToggle = document.querySelector('.mobile-menu-toggle');
  var mainNav = document.querySelector('.main-nav');
  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', function() {
      mainNav.classList.toggle('open');
      this.textContent = mainNav.classList.contains('open') ? '✕' : '☰';
    });
  }

  // Vehicle finder tabs
  var finderTabs = document.querySelectorAll('.finder-tab');
  finderTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      finderTabs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      var panels = document.querySelectorAll('.finder-panel');
      panels.forEach(function(p) { p.style.display = 'none'; });
      var target = document.getElementById(this.dataset.target);
      if (target) target.style.display = 'flex';
    });
  });

  // Model year data
  var modelYears = {
    'cherokee': genRange(1996, 2020),
    'commander': genRange(2005, 2010),
    'compass': genRange(2007, 2020),
    'gladiator': [2020],
    'grand-cherokee': genRange(1996, 2020),
    'liberty': genRange(2002, 2012),
    'patriot': genRange(2007, 2017),
    'renegade': genRange(2015, 2020),
    'wrangler': genRange(1996, 2020)
  };

  function genRange(start, end) {
    var arr = [];
    for (var y = end; y >= start; y--) arr.push(y);
    return arr;
  }

  // Populate years when model changes
  var modelSelect = document.getElementById('finder-model');
  var yearSelect = document.getElementById('finder-year');

  if (modelSelect && yearSelect) {
    modelSelect.addEventListener('change', function() {
      var model = this.value;
      yearSelect.innerHTML = '<option value=>Select Year</option>';
      if (model && modelYears[model]) {
        modelYears[model].forEach(function(yr) {
          var opt = document.createElement('option');
          opt.value = yr;
          opt.textContent = yr;
          yearSelect.appendChild(opt);
        });
        yearSelect.disabled = false;
      } else {
        yearSelect.disabled = true;
      }
    });
  }

  // Find My PCM button
  var finderGo = document.getElementById('finder-go');
  if (finderGo) {
    finderGo.addEventListener('click', function() {
      var model = modelSelect ? modelSelect.value : '';
      if (!model) { modelSelect.focus(); return; }
      window.location.href = '/collections/jeep-' + model;
    });
  }

  // Product tabs
  var tabBtns = document.querySelectorAll('.tab-btn');
  var tabContents = document.querySelectorAll('.tab-content');
  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      tabBtns.forEach(function(b) { b.classList.remove('active'); });
      tabContents.forEach(function(c) { c.classList.remove('active'); });
      this.classList.add('active');
      var target = document.getElementById(this.dataset.tab);
      if (target) target.classList.add('active');
    });
  });

  // Quantity selector
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus = document.querySelector('.qty-plus');
  var qtyInput = document.querySelector('.qty-input');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value) || 1;
      qtyInput.value = v + 1;
    });
  }

  // Collection filters
  var filterCheckboxes = document.querySelectorAll('.filter-group input[type=checkbox]');
  filterCheckboxes.forEach(function(cb) {
    cb.addEventListener('change', filterProducts);
  });

  function filterProducts() {
    var checkedYears = getChecked('filter-year');
    var checkedEngines = getChecked('filter-engine');
    var cards = document.querySelectorAll('.product-card');
    var visibleCount = 0;

    cards.forEach(function(card) {
      var year = card.dataset.year;
      var engine = card.dataset.engine;
      var yearMatch = checkedYears.length === 0 || checkedYears.indexOf(year) > -1;
      var engineMatch = checkedEngines.length === 0 || checkedEngines.indexOf(engine) > -1;
      if (yearMatch && engineMatch) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    var countEl = document.querySelector('.product-count');
    if (countEl) {
      countEl.textContent = visibleCount + ' products available';
    }
  }

  function getChecked(name) {
    var boxes = document.querySelectorAll('input[name= + name + ]:checked');
    return Array.from(boxes).map(function(b) { return b.value; });
  }

  // Sort
  var sortSelect = document.querySelector('.sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var grid = document.querySelector('.product-grid');
      if (!grid) return;
      var cards = Array.from(grid.querySelectorAll('.product-card'));
      cards.sort(function(a, b) {
        var s = sortSelect.value;
        if (s === 'price-low') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        if (s === 'price-high') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        if (s === 'year-new') return parseInt(b.dataset.year) - parseInt(a.dataset.year);
        if (s === 'year-old') return parseInt(a.dataset.year) - parseInt(b.dataset.year);
        if (s === 'name-az') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
        return 0;
      });
      cards.forEach(function(card) { grid.appendChild(card); });
    });
  }

});
